import { FunctionComponent, useEffect, useState, useRef } from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
  Typography,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  TablePagination,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router-dom";
import AboneSicilListeAPI from "../../../apis/OB/Get/AboneSicilListeAPI";
import AbonelerAPI from "../../../apis/OB/Get/AbonelerAPI";
import ArizaBasvuruSaveAPI from "../../../apis/OB/SaveApi/ArizaBasvuru";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import { displayValue } from "../../../helpers/TodayDate";
import Recaptcha from "../../../components/Recaptcha";
import { toast } from "react-toastify";

const ArizaBasvuru: FunctionComponent = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [aboneData, setAboneData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [aktifAboneVarMi, setAktifAboneVarMi] = useState<boolean>(false);

  const [data, setData] = useState<any[]>([]);
  const [checkedIndex, setCheckedIndex] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(4);
  const [popupContent, setPopupContent] = useState<string>("");
  let user = SessionStorageService.getUserInfo();
  const navigate = useNavigate();
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [userControlPopup, setUserControlPopup] = useState<boolean>(false);
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [popupAciklama, setPopupAciklama] = useState<string>("");

  const [kayitBasarili, setKayitBasarili] = useState<boolean>(false);
  const [aciklamaPopUpVisible, setAciklamaPopUpVisible] = useState<boolean>(false);

  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);

  };
  useEffect(() => {
    if (!user) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, [user]);

  const closePopup = () => {
    setIsPopupVisible(false);
    setAciklamaPopUpVisible(false);
    if (aktifAboneVarMi === false) {
      navigate(-1)
    }
  };



  const openPopup = (content: string) => {
    setPopupContent(content);
    setAciklamaPopUpVisible(true);
  };

  const fetchData = () => {
    if (user) {
      setIsLoading(true);
      AboneSicilListeAPI.getAboneSicilListe(
        user?.sicilKodu,
        formik.values.aboneNo === -1 ? undefined : formik.values.aboneNo
      )
        .then((res) => {
          console.log(res.data)

          setData(res.data)

        })
        .catch((err) => {
          console.error("Abone Sicil Liste API hatası:", err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (user) {
      setIsLoading(true);
      AboneSicilListeAPI.getAboneSicilListe(
        user?.sicilKodu,
        formik.values.aboneNo === -1 ? undefined : formik.values.aboneNo
      )
        .then((res) => {
          console.log(res.data)
          if (res.data.length > 0) {
            setData(res.data)
            setAboneData(res.data)
          } else {
            openPopup("Kayıt bulunamadı!");
          }
        })
        .catch((err) => {
          console.error("Abone Sicil Liste API hatası:", err);
        })
      AbonelerAPI.getAbonelerListe(1,user?.sicilKodu)
        .then((res) => {
          if (res.data.length > 0) {
            setAktifAboneVarMi(true)
          } else {
            openPopup("Aktif bir aboneliğiniz bulunmadığı için bu sayfa da işlem yapamazsınız.");

          }
        })
        .catch((err) => {
        });
      setIsLoading(false);
    }

  }, []);
  const clearAllInputs = () => {
    formik.resetForm();
    setCheckedIndex(null);
    fetchData()
  };

  const formik = useFormik({
    initialValues: {
      aboneNo: -1,
      aciklama: "",
    },
    validationSchema: Yup.object({
      aboneNo: Yup.number(),
      aciklama: Yup.string().required("Açıklama giriniz"),
    }),
    onSubmit: async (values) => {
      if (checkedIndex === null) {
        openPopup("Lütfen bir abone seçiniz.");
        return;
      }
       // reCAPTCHA’yı tetikle
      const token = await recaptchaRef.current?.handleSubmit();
      if (!token) {
        toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
        return;
      }
      const request = {
        sicilKodu: user?.sicilKodu,
        basvuruTuruId: 305,
        aboneNo: checkedIndex,
        islemTuruKodu: 1,
        sonEndeks: 0,
        aciklama: values.aciklama,
        captchaToken: token
      };
      ArizaBasvuruSaveAPI.saveArizaBasvuruSave(request)
        .then((res) => {
          if (res.data.sonuc === 0) {
            let basvuruNo = res.data.basvuruNo;
            setPopupAciklama(
              "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
              basvuruNo
            );
            setKayitBasarili(true);
          } else {
            setPopupAciklama(res.data.sonucAciklama);
          }
        })
        .catch((err) => {
          setPopupAciklama(
            "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
          );
        })
        .finally(() => {
          setIsPopupVisible(true);
          recaptchaRef.current?.reset();
        });
    },
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return isLoad ? (
    <>
      <div className="d-flex align-self-stretch justify-content-center align-items-center">
        <CircularProgress />
      </div>
      {userControlPopup && (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />
      )}
    </>
  ) : (
    <>
      <Card>
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  size="small"
                  select
                  fullWidth
                  label="Abone No"
                  value={formik.values.aboneNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="aboneNo"
                  error={formik.touched.aboneNo && Boolean(formik.errors.aboneNo)}
                  helperText={formik.touched.aboneNo && formik.errors.aboneNo}
                >
                  <MenuItem value={-1}>Abone No</MenuItem>
                  {aboneData.map((item, index) => (
                    <MenuItem key={index} value={item.aboneNo}>
                      {item.aboneNo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                container
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item>
                  <Button variant="contained" onClick={fetchData}>
                    Ara
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={clearAllInputs}>
                    Temizle
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <Typography>Loading...</Typography>
                ) : (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Abone No</TableCell>
                          <TableCell>Abone Tipi</TableCell>
                          <TableCell>Sayaç Markası</TableCell>
                          <TableCell>Sayaç No</TableCell>
                          <TableCell>Adres</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data
                          .slice(
                            currentPage * rowsPerPage,
                            currentPage * rowsPerPage + rowsPerPage
                          )
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Checkbox
                                  checked={checkedIndex === Number(item.aboneNo)}
                                  onChange={() => {
                                    if (checkedIndex === Number(item.aboneNo)) {
                                      setCheckedIndex(null);
                                    } else {
                                      setCheckedIndex(Number(item.aboneNo));
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell>{item.aboneNo}</TableCell>
                              <TableCell>{item.aboneTipi}</TableCell>
                              <TableCell>{displayValue(item.sayacMarkası)}</TableCell>
                              <TableCell>{item.sayacNo}</TableCell>
                              <TableCell>{item.adres}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[4, 10, 25]}
                      component="div"
                      count={data.length}
                      rowsPerPage={rowsPerPage}
                      page={currentPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  label="Açıklama"
                  value={formik.values.aciklama}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="aciklama"
                  error={formik.touched.aciklama && Boolean(formik.errors.aciklama)}
                  helperText={formik.touched.aciklama && formik.errors.aciklama}
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid className="d-flex justify-content-end" item xs={12}>
                <Recaptcha
                  ref={recaptchaRef}
                  changeHandleRecaptcha={setRecaptchaPassed}
                />
                <Button variant="contained" type="submit">
                  Gönder
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      {isPopupVisible && (
        <BilgilendirmePopup
          basvuruTuruId={-5}
          isSorunBildirPopup={!kayitBasarili}
          closePopup={closePopup}
          open={isPopupVisible}
          editDescription={popupAciklama}
        />
      )}
      {aciklamaPopUpVisible && (
        <AciklamaAndUserControlPopup
          open={aciklamaPopUpVisible}
          handleClose={closePopup}
          isUserControlPopUp={false}
          description={popupContent}
        />
      )}</>
  );
};

export default ArizaBasvuru;
